import {
  DEFAULT_LANGUAGE,
  isLanguageCode,
  type LanguageCode,
} from '../shared/languages';
import type { RootState } from './store';

export const selectLanguage = (state: RootState): LanguageCode => {
  const language = state.routing.params?.language;
  return typeof language === 'string' && isLanguageCode(language)
    ? language
    : DEFAULT_LANGUAGE;
};

export const selectRouteParams = (state: RootState) => state.routing.params;

export const selectRouteQuery = (state: RootState) => state.routing.query;
